module.exports = __webpack_public_path__ + "static/media/background.2fe77a7f.png";